import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getRequiredFieldStatus } from '../../utils/requiredFieldStatus'

const POLL_MS = 400

const RequiredFieldsBadge = ({ step }) => {
	const { t } = useTranslation('common')
	const [status, setStatus] = useState({ total: 0, missing: 0 })

	useEffect(() => {
		const poll = () => {
			const { total, missing } = getRequiredFieldStatus()
			setStatus(prev =>
				prev.total === total && prev.missing === missing ? prev : { total, missing }
			)
		}
		poll()
		const id = setInterval(poll, POLL_MS)
		return () => clearInterval(id)
	}, [step])

	if (status.missing === 0) return null

	return (
		<div className='required-fields-badge'>
			{t('requiredFieldsRemaining', { count: status.missing })}
		</div>
	)
}

export default RequiredFieldsBadge
